import React from "react";

function FooterCompany() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="company">
            &copy; {currentYear} Etransport
        </div>
    );
}

export default FooterCompany;
